import React from "react"
import { Flex, Box } from "@mantine/core"
import OffsetBackground from "../OffsetBackground/OffsetBackground"

type imagePosition = "left" | "right"

interface SideImageContainerProps {
	backgroundImage: string
	bgPosition: string
	bgSize: string | number
	imagePosition: imagePosition
	children: React.ReactNode
}

const SideImageContainer: React.FC<SideImageContainerProps> = ({
	backgroundImage,
	bgPosition,
	bgSize,
	imagePosition,
	children
}) => {
	const borderRadius =
		imagePosition === "left" ? "0 180px 180px 0" : "180px 0 0 180px"

	return (
		<Flex
			direction={{
				base: "column",
				md: imagePosition === "right" ? "row-reverse" : "row"
			}}
			gap="md"
			style={{ width: "100%" }}
		>
			<Box
				style={{ borderRadius, overflow: "hidden" }}
				w={{ base: "100%", md: "50%" }}
			>
				<OffsetBackground
					backgroundImage={backgroundImage}
					backgroundPosition={bgPosition}
					backgroundSize={bgSize}
				/>
			</Box>
			<Flex
				w={{ base: "100%", md: "50%" }}
				direction="column"
				justify="center"
				align="center"
				p="xl"
			>
				{children}
			</Flex>
		</Flex>
	)
}

export default SideImageContainer
